module.exports = __webpack_public_path__ + "static/media/sales_support.79edf26b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/sales_support.svg
// module id = 1098
// module chunks = 36